export const LEGAL_SOCIAL_LOGIN: string = `

### <!--= ++sectionIndex -->. Soziale Anmeldung
<!-- subSectionIndex = 0; -->

Auf unserer Website bieten wir Ihnen die Möglichkeit, sich mit einem Ihrer bestehenden Social-Media-Konten zu registrieren und anzumelden. Wenn Sie dies tun, beachten Sie bitte, dass Sie bestimmte Profilelemente mit uns teilen. Dazu können je nach Plattform Ihr Name, Ihre E-Mail-Adresse und möglicherweise Ihr Profilbild gehören. Diese Informationen werden vom Social-Media-Anbieter gesammelt und gemäß seiner Datenschutzrichtlinie an uns übermittelt.

Bitte beachten Sie, dass Sie bei der Verwendung dieser Social-Login-Dienste nicht nur unserer Datenschutzrichtlinie, sondern auch den Datenschutzrichtlinien der jeweiligen Anbieter unterliegen.

<!-- if (addons.socialLogin.facebook) { -->
#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. Facebook

Wir haben den Dienst Facebook Login integriert, um Ihnen die Verbindung Ihres Facebook-Profils mit unserem Dienst zu ermöglichen. Wenn Sie sich für die Nutzung entscheiden, erhalten wir von Facebook Ihre öffentlich verfügbaren Profilinformationen.

Verantwortlicher für Facebook Login ist Facebook Ireland Ltd., 4 GrandCanal Square, Grand Canal Harbour, Dublin 2, Irland.

Wenn Sie sich für die Nutzung von Facebook Login entscheiden, können Ihre Daten in die USA übermittelt werden. Die Datenübertragung in die USA basiert auf den Standardvertragsklauseln der EU-Kommission.

Weitere Einzelheiten finden Sie unter: [Datenschutzrichtlinie von Facebook](https://www.facebook.com/about/privacy/)
<!-- } -->

<!-- if (addons.socialLogin.apple) { -->
#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. Apple

Wir verwenden Apple Login als eine unserer Anmelde-/Login-Optionen. Wenn Sie sich dafür entscheiden, teilt Apple uns Ihren Namen und Ihre E-Mail-Adresse mit, damit wir Ihr Konto erstellen und betreuen können. Die Datenverarbeitung erfolgt auf Grundlage Ihrer Einwilligung gemäß Artikel 6(1)(a) DSGVO.

Anbieter ist Apple Inc., One Apple Park Way, Cupertino, CA 95014, USA

Die Datenschutzrichtlinie von Apple können Sie hier einsehen: [Datenschutzrichtlinie anwenden](https://www.apple.com/legal/privacy/)
<!-- } -->

<!-- if (addons.socialLogin.google) { -->
#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. Google

Wir verwenden auf unserer Website Google Login, einen Dienst der Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA

Google Login ermöglicht Ihnen, sich mit den Anmeldedaten Ihres Google-Kontos auf unserer Website anzumelden. Wenn Sie diese Option nutzen, erhalten wir Ihre E-Mail-Adresse, Ihren Namen und Ihr Profilbild aus Ihrem Google-Profil.

Die Datenübertragung in die USA wird auf die Standardvertragsklauseln der EU-Kommission gestützt.

Weitere Informationen zum Datenschutz bei Google finden Sie unter [Datenschutzrichtlinie von Google](https://policies.google.com/privacy)
<!-- } -->
`;
